import { render, staticRenderFns } from "./my-program.vue?vue&type=template&id=180e73ca&scoped=true"
import script from "./my-program.vue?vue&type=script&lang=js"
export * from "./my-program.vue?vue&type=script&lang=js"
import style0 from "./my-program.vue?vue&type=style&index=0&id=180e73ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e73ca",
  null
  
)

export default component.exports